
import React from 'react'
import Profile from '../../components/profile/Profile'
import PageBar from '../../components/dashboard/page-bar/PageBar'

const ProfilePage = () => {
    return (
        <>
            <div className="pageWrapper">
                <PageBar title="Profile" />
                <Profile />
            </div>

        </>
    )
}

export default ProfilePage